<template lang="pug">
.calendar-month--row.weeks
  .calendar-month--cell.pa-2.text-center(
    v-for="day in SHORT_DAYS"
    :key="day"
  ).font-weight-bold.caption {{ day }}

</template>
<script>
import { SHORT_DAYS } from '@/constants';

export default {
  data() {
    return {
      SHORT_DAYS,
    };
  },
};
</script>

<style lang="scss">
.weeks{
  .calendar-month--cell {
    min-height: 20px;
  }
}
</style>
